import PerformanceRow from "../../models/PerformanceRow"
import Utils from "../../portlibs/PortUtils";
import TableUtils from "../../portlibs/TableUtils";
import PortUtils from "../../portlibs/PortUtils";
import GUI from "../../gui/GUI";
import Table from "../../gui/Table/Table";

export interface ISectorProps {
    cols:string[];
    rows:PerformanceRow[];
}
export default function SectorTable(props:ISectorProps){
    const {cols,rows} = props;

    const cell = (row:PerformanceRow, col:string) => row.value(col)
    const cellProp = (row:PerformanceRow, col:string) => ( {className:GUI.joinClass(PortUtils.cellClass(col, (row as any)[col]),TableUtils.align(col))} )
    const header = (col:string) => Utils.label(col)
    const headerProps = (col:string) => ({className:TableUtils.align(col)})
    const rowKey = (row:PerformanceRow) => row.sector?.toString() || "Unknown"
    return <Table tableName="sectors" rows={rows} cols={cols} rowKey={rowKey} cellText={cell} td={cellProp} label={header} th={headerProps}/>
}